import React from 'react'
import {BootstrapDialog} from "./Book.style"
import Skeleton from '@mui/material/Skeleton';
import DialogContent from "@mui/material/DialogContent";
import Image from "next/image";
import { getImage } from "../../helpers/images";
import {useQuery} from '@tanstack/react-query'
import Avatar from "@mui/material/Avatar";
import Stack from "@mui/material/Stack";
import { useState, useEffect } from "react";
import style from "../../../styles/mystyle.module.css";
import config from "../../../next.config";
import axios from 'axios';
export default function EntityImag({entityId}) {
    const [Open, setOpen] = useState(false);
    async function getImages(){
    
        return await axios
        .get(`${config["basePath"]}/api/registeration/entityImages/getImagesFromCache`, {
          params: {
            entityDetailsId:entityId,
            entityImageType: ["logo"],
          },
        })
        .then(async (entitiesImgs) => {
    
          let tempData = entitiesImgs.data.data.filter(ele=>ele.imageType&&ele.imageType.code=="logo");
          let newLst2=[]
          for(let i=0;i<=tempData.length-1;i++){
            if (tempData[i].files) {
             let img=await getImage(tempData[i].files.fileId,tempData[i].files.filePath)
              tempData[i].image=img
              newLst2.push(Object.assign(tempData[i],{image:img}))
             }
          }
    
        //   callbackImage([...newLst2]);
          return tempData
        })      .catch((err) => console.log("err========>",err));
      }
    const handleClickOpen = () => {
        setOpen(true);
      };
      const handleClose = () => {
        setOpen(false);
      };
      const {data,isLoading,status} = useQuery({queryKey: ['entityImages',entityId], queryFn:async()=>await getImages() })
  return (
    <div> <Stack
    direction="row"
    spacing={1}
    className={style.StackBook}
    suppressHydrationWarning

  >
    {/* {console.log("data========>",data)} */}
   {isLoading==false?<div onClick={handleClickOpen}     suppressHydrationWarning>
   
        <Avatar
          alt="Profile"
          src={data&&data.length>0&&data[0].image?data[0].image:`${config.basePath}/assest/logo.svg`}
          className={
            style.sizeAvatarcard + " " + style.Cursor
          }
          loading="lazy"
        />
   
    </div>:    <div><Skeleton variant="circular" width={120} height={120}   className={
            style.sizeAvatarcard + " " + style.Cursor
          }  /></div>  
}
  </Stack>

  <BootstrapDialog
    onClose={handleClose}
    aria-labelledby="customized-dialog-title"
    open={Open}
  >
    <DialogContent dividers>
      <Stack
        direction="row"
        spacing={1}
        className={style.Stack}
      >
        <div className={style.avater}>
       
            <div
              className={style.sizeAvatarWithoutborder}
            >
              {status=="success"&&<Image
              // onLoad={()=> data.length>0&&data[0].image?data[0].image&&URL.revokeObjectUrl(data[0].image):""}
                alt="Profile"
            
                src={data&&data.length>0&&data[0].image?data[0].image:`${config.basePath}/assest/logo.svg`}
                className={
                  style.sizeAvatarWithoutborder
                }
                // layout="fill"
                sizes={
                  "(max-width:768px) 100vw,(max-width:1200px) 50vw,32vw"
                }
                width={100}
                height={100}
              />}
            </div>
        
        </div>
      </Stack>
    </DialogContent>{" "}
  </BootstrapDialog></div>
  )
}
